import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AppConfig } from 'src/app/configs/app.config';
import { ToastService } from '../services/toast.service';

@Injectable()
export class ServerInterceptor implements HttpInterceptor {

    constructor(
        private auth: AuthService,
        private toast: ToastService
    ) { }

    exceptionList = [
        AppConfig.ICON_FILE
    ]

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq;
        if (req.headers.get('Authorization') == null && this.exceptionList.indexOf(req.url) < 0) {
            authReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this.auth.tokens.access_token)
            });
        } else {
            authReq = req.clone();
        }
        return next.handle(authReq).pipe(
            map((event: HttpEvent<any>) => {
                // console.log(req);
                // console.log(event);
                if (event instanceof HttpResponse && event.status == 200) {
                    if (typeof event.body.message != 'undefined' && event.body.message != 1000) {
                        // console.log(event);
                        this.processErrorCode(event.body.message, event.body.detail)
                    }
                }
                return event;
            }),
            catchError((err: any, caught) => {
                if (err instanceof HttpErrorResponse) {
                    // if (err.status === 403) {
                    //   console.info('err.error =', err.error, ';');
                    // }
                    // if (err.status >= 500) {
                    //   console.info('err.error =', err.error, ';');
                    // }
                    this.processErrorResponse(err.status);
                    return Observable.throw(err);
                }
            })
        );
    }

    processErrorResponse(statusCode) {
        // this.events.publish("provider:notice", 9999);
    }

    timer;
    processErrorCode(code, detail) {
        // 刷新token
        if (code == 1001) {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.auth.refreshToken();
            }, 200);
        }
        else if (code == 1002) {
            localStorage.removeItem('blinker_token_sso');
            this.auth.gotoSSO();
        } else {
            this.toast.show(`${code}: ${detail}`, { type: 'warn', delay: 8000 })
        }

    }

}